import { HttpClient } from './types';


export const createUserClientService = (httpClient: HttpClient) => {
  const getEndpoint = (url: string): string => `/clientes${url}`;

  return {
    getAllClients: <TClient = any>(): Promise<TClient[]> => {
      return httpClient.get<TClient[]>(getEndpoint(''));
    },

    createClient: <TClientDTO = any, TResponse = any>(client: TClientDTO): Promise<TResponse> => {
      return httpClient.post<TResponse>(getEndpoint(''), client);
    },

    updateClient: <TClientDTO = any, TResponse = any>(
      clientId: string,
      client: TClientDTO
    ): Promise<TResponse> => {
      return httpClient.put<TResponse>(getEndpoint(`/${clientId}`), client);
    },

    deleteClient: <TResponse = any>(clientId: string): Promise<TResponse> => {
      return httpClient.delete<TResponse>(getEndpoint(`/${clientId}`));
    },

    selectClient: <TResponse = any>(clientId: string): Promise<TResponse> => {
      return httpClient.put<TResponse>(getEndpoint(`/${clientId}/seleccionar`), {});
    },
  };
};

